import React, {useCallback, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import MarkdownLoader from '../../landing/MarkdownLoader';
import SignatureInput from '../../../cmp/form/SignatureInput';
import {FormattedMessage} from 'react-intl';
import Button from '../../../cmp/form/Button';
import {get, getAccessToken, post} from '../../../../api';
import Spinner from '../../../cmp/Spinner';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import FormRenderer from '../../../cmp/formbuilder/FormRenderer';
import FormGroup from '../../../cmp/form/FormGroup';
import {trimPostData} from '../../../../tools/func';

function DisplayContract() {
    const [signature, setSignature] = useState({
        pixelArray:[],
        dataURL: null
    })
    const [loading, setLoading] = useState(false)
    const [contractData, setContractData] = useState(null)
    const [signing, setSigning]= useState(false)
    const [error, setError] = useState(null)
    const [signed, setSigned] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()

    useEffect(()=>{
       if(!getAccessToken()){
           navigate('/login?next=' + location.pathname)
       }else{
           setLoading(true)
           get('/contract/' + params.contract_id)
           .then((data) => {
               if(data.file){
                   setContractData({file: data.file})
               }else if(data.error){
                   setError(data.error)
               } else if(data.contract){
                   setContractData(data.contract)
               }
               setLoading(false)
           }).catch(() => {
               setLoading(false)
           })
       }
    },[location.pathname, navigate, params.contract_id])
    const [customData, setCustomData] = useState({})

    const saveContract = useCallback((e) => {
        const {dataURL} = signature
        setSigning(true)
        setError(null)
        post('/contract/' + params.contract_id, {
            signature: dataURL,
            customData: trimPostData(customData),
        }).then((data) => {
            if (data.url) {
                setSigned(true)
                setContractData({file: data})
            }
            setSigning(false)
        }).catch((e) => {
            setSigning(false)
            setError(true)
        })
    },[params.contract_id, customData, signature])

    const onChangeSignature = useCallback((e) => {
            setSignature({
                pixelArray: e.target.value || [],
                dataURL: e.target.dataURL
            });
    },[])
       if (loading) {
            return <Container>
                <div className="text-center">
                    <Spinner/>
                </div>
            </Container>
        } else if (contractData && contractData.file && contractData.file.url) {
            return <Container>
                <p><FormattedMessage id={"Download the signed contract"}/></p>
                <a title={"Download"} href={contractData.file.url} download>
                    <FormattedMessage id={"Download"}/>
                </a>
            </Container>
        } else if (error) {
            return <Container>
                <span className={"text-danger"}>{error}</span>
            </Container>
        } else if (contractData && contractData.url) {
            return (
                <Container><>
                    <MarkdownLoader source={contractData.url}/>
                    {
                        contractData.custom_fields ? <>
                            <FormRenderer onChange={(data)=>{
                                setCustomData((d)=>{
                                    return data;
                                })
                            }}
                            value={customData}
                            formFields={contractData.custom_fields}/>
                            <Button onClick={saveContract} loading={signing}
                                    className={"btn btn-primary"}>
                                <FormattedMessage id={"Submit"}/>
                            </Button>
                            </> :<>
                            <FormGroup label={"Signature"}>
                                <SignatureInput onChange={onChangeSignature}
                                                value={signature.pixelArray}/>
                            </FormGroup>
                            <Button onClick={saveContract} loading={signing}
                                    disabled={signature.pixelArray.length === 0} className={"btn btn-primary"}>
                                <FormattedMessage id={"I agree"}/>
                            </Button>
                        </>
                    }
                </>
                </Container>
            );
        } else {
            return <Container><span className={"text-danger"}>No contract found</span>
            </Container>
        }
}

function Container({children}) {
    return <div className={'py-4'}>
        <div className="py-4 container">
            <div className="mt-4 card">
                <div className="card-body">
                    {children}
                </div>
            </div>
        </div>
    </div>
}

function mapStateToProps(state) {
    const {name, email} = state.settings;
    return {
        contract_html: state.settings.contract_html,
        access_token: state.settings.access_token,
        name, email
    }
}

export default connect(mapStateToProps)(DisplayContract);
